import { Button, Input, Modal } from 'antd'
import React, { useMemo } from 'react'

const MultiBinEdit = ({ onSubmit, onCancel, elements }) => {
  // Convert Set to Array for handling
  const elementsArray = useMemo(() => Array.from(elements), [elements]);
  
  const [maxCapacity, setMaxCapacity] = React.useState(
    elementsArray.length > 0 ? elementsArray[0].maxCapacity : null
  );

  const handleInputChange = (e) => {
    setMaxCapacity(e.target.value);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ maxCapacity: maxCapacity === "" ? null : Number(maxCapacity) });
  }

  return (
    <Modal
      title="Edit Selected Bins"
      open={true}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Save Changes
        </Button>,
      ]}
    >
      <div style={{ padding: '20px 0' }}>
        <p>Updating {elementsArray.length} selected bins.</p>
        <div style={{ marginBottom: '16px' }}>
          <label htmlFor="maxCapacity" style={{ display: 'block', marginBottom: '8px' }}>
            Max Capacity
          </label>
          <Input 
            type="number" 
            id="maxCapacity" 
            name="maxCapacity" 
            value={maxCapacity} 
            onChange={handleInputChange} 
            placeholder="Enter max capacity"
          />
        </div>
      </div>
    </Modal>
  )
}

export default MultiBinEdit